import { footer } from '@/mocks/chigua';

export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-ink-900 text-paper-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-600 text-paper-50">
                <i className="ri-leaf-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-paper-50">{footer.brand}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-[1.8] text-paper-100/70">{footer.slogan}</p>
            <div className="mt-5 flex items-center gap-2 text-xs text-paper-100/50">
              <i className="ri-shield-check-line" />
              信源分级 · 修订透明 · 断然不追谣
            </div>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-ocher-300">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      onClick={(e) => {
                        e.preventDefault();
                        document.getElementById('index')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-paper-100/70 transition-colors hover:text-paper-50"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-paper-100/15 pt-6 text-xs text-paper-100/55 sm:flex-row sm:items-center sm:justify-between">
          <p>{footer.rights}</p>
          <button
            onClick={goTop}
            className="flex items-center gap-1.5 whitespace-nowrap text-paper-100/70 transition-colors hover:text-paper-50"
          >
            回到顶部
            <i className="ri-arrow-up-line" />
          </button>
        </div>
      </div>
    </footer>
  );
}